import { useState, useEffect } from 'react';

import { TeamResponseDto, PagedResponse } from '@bandido/shared/dtos';

export const useVisibleChips = (
  containerRef: React.RefObject<HTMLDivElement>,
  teams: string[],
  teamsList: PagedResponse<TeamResponseDto> | undefined,
): number => {
  const [visibleCount, setVisibleCount] = useState(0);

  useEffect(() => {
    if (!containerRef.current) return;

    const calculateVisibleChips = () => {
      const containerWidth = containerRef.current!.offsetWidth - 32;
      let totalWidth = 0;
      let count = 0;

      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      if (context) {
        for (const chip of teams) {
          const { name = '' } = teamsList?.items.find((t) => t.id === +chip) ?? {};
          const chipTextWidth = context.measureText(name).width + 70;

          if (totalWidth + chipTextWidth > containerWidth) break;

          totalWidth += chipTextWidth + 8;
          count++;
        }
      }

      setVisibleCount(count);
    };

    calculateVisibleChips();
  }, [teams, teamsList, containerRef]);

  return visibleCount;
};
